module.exports = __webpack_public_path__ + "img/foto-panoramica-riodejaneiro.5f7f7047.jpg";